import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { adminFormAction } from "../../redux/rootReducer";
import { ADMIN_FORM_INITIAL } from "../../redux/initialStateConstant";
import { resetAdminPasswordSagaAction, updateAdminByIdSagaAction } from "../../redux/sagaActions";
import Checkbox from "../Checkbox/Checkbox";

const AdminForm = () => {
    const dispatch = useDispatch();
    const admin_form = useSelector(state => state.admin_form);
    const establishmentList = useSelector(state => state.establishmentList);

    if (!admin_form.open) return false;

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close" onClick={ () => dispatch(adminFormAction(ADMIN_FORM_INITIAL)) }/>
                        <div className="form__title">Администратор</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Имя</div>
                        <input type="text" className="input"
                            value={ admin_form.name }
                            onInput={ event => dispatch(adminFormAction({ ...admin_form, name: event.target.value })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Телефон</div>
                        <input type="text" className="input"
                               value={ admin_form.phone }
                               onInput={ event => dispatch(adminFormAction({ ...admin_form, phone: event.target.value })) }
                        />
                    </div>
                    {
                        admin_form.restrictions.length > 0 &&
                        <div className="form__field">
                            <div className="input__caption">Ограничения</div>
                            {
                                admin_form.restrictions.map(elem => (
                                    <div style={{ marginTop: '8px' }} key={ elem.id }>
                                        <Checkbox
                                            active={ elem.active === '1' }
                                            caption={ elem.name }
                                            handler={ () => {
                                                dispatch(adminFormAction({
                                                    ...admin_form,
                                                    restrictions: admin_form.restrictions.map(el => {
                                                        if (el.name === elem.name) {
                                                            return { ...el, active: el.active === '1' ? '0' : '1' }
                                                        }
                                                        else {
                                                            return { ...el };
                                                        }
                                                    })
                                                }));
                                            } }
                                        />
                                    </div>
                                ))
                            }
                        </div>
                    }
                    <div className="form__field">
                        <div className="input__caption input__caption--required" style={{ marginBottom: '10px' }}>Для каких заведений</div>
                        {
                            establishmentList.map(elem => {
                                return (
                                    <div style={{ marginBottom: '10px' }} key={ elem.id }>
                                        <div className="checkbox__wrapper" onClick={ () => {
                                            // Старый массив с заведениями
                                            let est = [...admin_form.establishments];
                                            // Ищем индекс выбранного элемента
                                            let findIndex = est.findIndex(el => el === elem.id);
                                            // Если в массиве есть выбранный элемент, удаляем его
                                            if (findIndex + 1) {
                                                est.splice(findIndex, 1);
                                            }
                                            else {
                                                est.push(elem.id);
                                            }

                                            dispatch(adminFormAction({
                                                ...admin_form,
                                                establishments: est
                                            }));

                                        } }>
                                            <div className={ `checkbox ${ admin_form.establishments.includes(elem.id) ? 'checkbox--active' : '' }` }/>
                                            <div className="checkbox__caption">{ elem.name }</div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    {
                        admin_form.id &&
                        <div className="form__field">
                            <div className="form__reset" onClick={
                                () => {
                                    if (!window.confirm('Вы действительно хотите сбросить пароль администратора?')) return;
                                    dispatch(resetAdminPasswordSagaAction({ id: admin_form.id }))
                                }
                            }>Сбросить пароль</div>
                        </div>
                    }
                    <div className="form__field">
                        <div className="button" onClick={ () => dispatch(updateAdminByIdSagaAction({
                            id: admin_form.id,
                            name: admin_form.name,
                            phone: admin_form.phone,
                            establishments: JSON.stringify(admin_form.establishments),
                            restrictions: JSON.stringify(admin_form.restrictions)
                        })) }>Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminForm;